"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregateSelectorDeclarations = void 0;
var get_static_computed_css_1 = require("./get-static-computed-css");
var stylable_aggregation_constants_1 = require("./stylable-aggregation-constants");
function matchRegex(selector, matcher) {
    var match = selector.match(matcher);
    return { match: match, name: match ? match[1] : '' };
}
var aggregateSelectorDeclarations = function (stylableDriver, sheetPaths, selector, filter, useRawDecl, 
// We don't open background shorthands since they are fully opened by the background-driver
disableBackgroundShorthand) {
    if (filter === void 0) { filter = stylable_aggregation_constants_1.DEFAULT_FILTER; }
    if (useRawDecl === void 0) { useRawDecl = false; }
    if (disableBackgroundShorthand === void 0) { disableBackgroundShorthand = true; }
    var sheets = (Array.isArray(sheetPaths) ? sheetPaths : [sheetPaths]).map(function (sheetPath) {
        return stylableDriver.getStylesheet(sheetPath);
    });
    if (!sheets.length) {
        return {};
    }
    var stateName = matchRegex(selector, stylable_aggregation_constants_1.SELECTOR_STATE_REGEX).name;
    // TODO: this is work around issue for when to filter -st- stuff related to states (should be removed)
    var filterDecl = stateName
        ? function (prop) { return prop !== '-st-extends' && prop !== '-st-states' && filter(prop); }
        : filter;
    try {
        return (0, get_static_computed_css_1.getStaticComputedCSS)(stylableDriver.stylable, sheets, selector, {
            filterDecl: filterDecl,
            useRawDecl: useRawDecl,
            disableBackgroundShorthand: disableBackgroundShorthand,
        }).decls;
    }
    catch (e) {
        throw new Error('getStaticComputedCSS error caused by:\n' + (e === null || e === void 0 ? void 0 : e.stack));
    }
};
exports.aggregateSelectorDeclarations = aggregateSelectorDeclarations;
//# sourceMappingURL=stylable-aggregation.js.map